module.exports = __webpack_public_path__ + "img/icon-camera.ab360373.svg";